import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import { api } from "@/services/Api";
import { CalendarSlot } from "@/models/Calendar";
import { CalendarSlotSaveResponse } from "@/models/Interfaces";
import _ from "lodash";
import Q from "q";
import mixins from "@/mixin";

export default function () {
  const { t } = useI18n();

  async function saveCalendarEditLimitQty(
    model: CalendarSlot,
    parentSlotDate: string,
    ignoreOrderWarning = false,
    ignoreStopSaleWarning = false
  ): Promise<CalendarSlotSaveResponse | null> {
    const resp = await api.saveCalendarEditLimitQty(
      model,
      parentSlotDate,
      ignoreOrderWarning,
      ignoreStopSaleWarning
    );
    if (resp.errorMessage || !resp.data) {
      const continueLoading = swal.isVisible() && swal.isLoading();
      if (resp.errorCode == 1) {
        const swalResult = await swal.fire({
          icon: "info",
          title: t("calendar.v3.warning.has_orders"),
          customClass: {
            confirmButton: "save-button-wrapper popup-bookit-button my-1 px-5",
            denyButton: "close-button-wrapper popup-bookit-button my-1 px-5",
          },
          buttonsStyling: false,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonText: t("alert.yesContinue"),
          denyButtonText: t("button.cancel"),
        });
        if (!swalResult.isConfirmed) return null;
        ignoreOrderWarning = true;
      }
      if (resp.errorCode == 3) {
        const swalResult = await swal.fire({
          icon: "info",
          title: t("calendar.v3.warning.has_stopsales", {
            start: mixins.methods.getDateToTitle(model.startDate.toString()),
            end: mixins.methods.getDateToTitle(
              (model.repeatEndDate || model.startDate).toString()
            ),
          }),
          customClass: {
            confirmButton: "save-button-wrapper popup-bookit-button my-1 px-5",
            denyButton: "close-button-wrapper popup-bookit-button my-1 px-5",
          },
          buttonsStyling: false,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonText: t("alert.yesContinue"),
          denyButtonText: t("button.cancel"),
        });
        if (!swalResult.isConfirmed) return null;
        ignoreStopSaleWarning = true;
      } else {
        swal.fire({
          title: resp.errorMessage || "Error",
          icon: "error",
        });
        return null;
      }
      if (continueLoading) {
        await Q.delay(150);
        swal.showLoading();
      }
      return await saveCalendarEditLimitQty(
        model,
        parentSlotDate,
        ignoreOrderWarning,
        ignoreStopSaleWarning
      );
    }
    return resp.data;
  }

  async function saveCalendarSlot(
    model: CalendarSlot,
    parentSlotDate: string,
    ignoreOrderWarning = false,
    ignoreStopSaleWarning = false
  ): Promise<CalendarSlotSaveResponse | null> {
    const resp = await api.saveCalendarSlot(
      model,
      parentSlotDate,
      ignoreOrderWarning,
      ignoreStopSaleWarning
    );
    if (resp.errorMessage || !resp.data) {
      const continueLoading = swal.isVisible() && swal.isLoading();
      if (resp.errorCode == 1) {
        const swalResult = await swal.fire({
          icon: "info",
          title: t("calendar.v3.warning.has_orders"),
          customClass: {
            confirmButton: "save-button-wrapper popup-bookit-button my-1 px-5",
            denyButton: "close-button-wrapper popup-bookit-button my-1 px-5",
          },
          buttonsStyling: false,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonText: t("alert.yesContinue"),
          denyButtonText: t("button.cancel"),
        });
        if (!swalResult.isConfirmed) return null;
        ignoreOrderWarning = true;
      }
      if (resp.errorCode == 3) {
        const swalResult = await swal.fire({
          icon: "info",
          title: t("calendar.v3.warning.has_stopsales", {
            start: mixins.methods.getDateToTitle(model.startDate.toString()),
            end: mixins.methods.getDateToTitle(
              (model.repeatEndDate || model.startDate).toString()
            ),
          }),
          customClass: {
            confirmButton: "save-button-wrapper popup-bookit-button my-1 px-5",
            denyButton: "close-button-wrapper popup-bookit-button my-1 px-5",
          },
          buttonsStyling: false,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonText: t("alert.yesContinue"),
          denyButtonText: t("button.cancel"),
        });
        if (!swalResult.isConfirmed) return null;
        ignoreStopSaleWarning = true;
      } else {
        swal.fire({
          title: resp.errorMessage || "Error",
          icon: "error",
        });
        return null;
      }
      if (continueLoading) {
        await Q.delay(150);
        swal.showLoading();
      }
      return await saveCalendarSlot(
        model,
        parentSlotDate,
        ignoreOrderWarning,
        ignoreStopSaleWarning
      );
    }
    return resp.data;
  }

  return {
    saveCalendarEditLimitQty,
    saveCalendarSlot
  };
}
